import Orientation from 'react-native-orientation-locker';

import { isIphoneDuo } from './get-device-model';

class AppOrientationController {
    lockToAllowed() {
        if (!isIphoneDuo) {
            Orientation.lockToPortrait();
        }
    }

    allowAll() {
        Orientation.unlockAllOrientations();
    }
}

export const AppOrientation = new AppOrientationController();
